export const formStates = {
  CLEAN: 'CLEAN',
  ERROR: 'ERROR',
  SUBMITTING: 'SUBMITTING',
};
